import script from "./AgentCoachPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentCoachPanel.vue?vue&type=script&setup=true&lang=js"

import "./AgentCoachPanel.vue?vue&type=style&index=0&id=ab83daee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab83daee"]])

export default __exports__